import { Stack } from "@mui/material";
import { PutawayQueueSettings } from "./NumberingConfigurationPage";
import { PageHeader } from "./PageHeader";

export function PutawayWorkQueuePage({ onBack }: { onBack: () => void }) {
  return (
    <Stack spacing={1.5}>
      <PageHeader title="Files de mise en stock" compact onBack={onBack} />
      <PutawayQueueSettings />
    </Stack>
  );
}
